const ENV_KEY = "REACT_APP_ENABLE_MFA";

function getConfiguredMfaFlag() {
  const runtimeConfig =
    typeof window !== "undefined" && window.config ? window.config[ENV_KEY] : undefined;

  return process.env[ENV_KEY] || runtimeConfig;
}

export function isMfaEnabled() {
  return String(getConfiguredMfaFlag()).toLowerCase() === "true";
}

export { ENV_KEY };
